import {MAX_NUM} from "../../../../bootstrap/utils/stats";
import __ from "../../../i18n";
import {CURRENCY_INPUT_UNIT} from '../../../view-constants/currency';


function getFiltersConfig() {
    return {
        id: {
            name: __('ID'),
            type: 'number',
            rules: {min: 0, max: MAX_NUM},
            options: {formatDisabled: true}
        },
        course_id: {
            name: __('Course ID'),
            type: 'number',
            rules: {min: 0, max: MAX_NUM},
            options: {formatDisabled: true}
        },
        student_id: {
            name: __('Student ID'),
            type: 'number',
            rules: {min: 0, max: MAX_NUM},
            options: {formatDisabled: true}
        },
        fee: {
            name: __('Fee'),
            type: 'number',
            rules: {min: 0, max: MAX_NUM},
            options: {
                suffix: ' ' + CURRENCY_INPUT_UNIT
            }
        },
    }
}

function getFilterableFields() {
    return Object.keys(getFiltersConfig());
}

export default {
    getFiltersConfig,
    getFilterableFields
};
